import SecurityMask, {SecurityMaskPropTypes} from './SecurityMask';

export type {SecurityMaskPropTypes};
export default SecurityMask;
